<template>
  <div>
    <b-row class="justify-content-center">
      <b-col md="4" class="d-flex justify-content-center my-1">
        <b-form-checkbox v-model="displayCalendar" name="check-button" switch inline >
          Calendar
        </b-form-checkbox>
      </b-col>
    </b-row>

    <div v-if="displayCalendar">
      <div class="app-calendar overflow-hidden border">
        <div class="row no-gutters">
          <!-- Calendar -->
          <div class="col-sm-12">
  <b-card>
    <b-card-title class="mb-1 text-center">Legend</b-card-title>
    <b-card-body class="d-flex flex-wrap justify-content-center">
      <b-badge variant="primary" class="mb-2 mx-1">Completed</b-badge>
      <b-badge variant="info" class="mb-2 mx-1">Not Started</b-badge>
      <b-badge variant="secondary" class="mb-2 mx-1">Started</b-badge>
      <b-badge variant="danger" class="mb-2 mx-1">Cancelled</b-badge>
      <b-badge variant="warning" class="mb-2 mx-1">Blocked</b-badge>
    </b-card-body>
  </b-card>
</div>

          <div class="col position-relative">
            <div class="card shadow-none border-0 mb-0 rounded-0">
              <div class="card-body pb-0">
                <full-calendar :plugins="calendarPlugins" :events="fcEvents" :options="calendarOptions" />
              </div>
            </div>
          </div>
          <b-sidebar id="sidebar-right" bg-variant="white" right title="View Job Card" backdrop shadow
            :visible="showSidebar" ref="sidebar">

            <b-button  size="sm" class="mt-1 w-100" @click="goToPage(selectedItem)">
                    View
                </b-button>

          </b-sidebar>
          <!-- Sidebar Overlay -->
        </div>
      </div>
    </div>

    <!-- Table -->
    <div v-else>
      <b-row>
        <b-col   cols="12" md="2" sm="2" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
          </b-form-group>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
          <b-button variant="outline-danger" @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredJobcards"
            :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            @row-clicked="onRowClicked">

            <template #head(name)="scope">
              <div class="d-flex flex-column">
                <span>Job Card Name</span>
                <b-form-input v-model="filters.name" placeholder="Search Job Card Name" size="sm"
                  @input="currentPage = 1" />
              </div>
            </template>

            <template #head(startDate)="scope">
              <div class="d-flex flex-column">
                <span>Start Date</span>
                <DatePicker v-model="filters.startDate" format="YYYY-MM-DD" placeholder="Select Start Date"
                  @change="currentPage = 1" style="width: 100%;" size="sm" />
              </div>
            </template>

            <template #head(endDate)="scope">
              <div class="d-flex flex-column">
                <span>End Date</span>
                <DatePicker v-model="filters.endDate" format="YYYY-MM-DD" placeholder="Select End Date"
                  @change="currentPage = 1" style="width: 100%;" size="sm" />
              </div>
            </template>

            <template #head(status)="scope">
              <div class="d-flex flex-column">
                <span>Status</span>
                <b-form-select v-model="filters.status" :options="statusOptions" size="sm" @input="currentPage = 1" />
              </div>
            </template>

            <!-- Priority Filter -->
            <template #head(priority)="scope">
              <div class="d-flex flex-column">
                <span>Priority</span>
                <b-form-select v-model="filters.priority" :options="priorityOptions" size="sm"
                  @input="currentPage = 1" />
              </div>
            </template>

            <template v-slot:cell(status)="data">
              <b-badge v-if="data.item.status === 0" variant="info">
                <span>Not Started</span>
              </b-badge>
              <b-badge v-else-if="data.item.status === 1" variant="secondary">
                <span>Started</span>
              </b-badge>
              <b-badge v-else-if="data.item.status === 2" variant="primary">
                <span>Completed</span>
              </b-badge>
              <b-badge v-else-if="data.item.status === 3" variant="danger">
                <span>Cancelled</span>
              </b-badge>
              <b-badge v-else-if="data.item.status === 4" variant="warning">
                <span>Blocked</span>
              </b-badge>
            </template>

            <template v-slot:cell(name)="data">
              <b-link variant="primary" :to="getId(data.item.id)">
                {{ data.item.name }}
              </b-link>
            </template>
            <template #cell(actions)="data">
              <!-- <b-dropdown v-if="data.item.status === 2" variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                </template>
                <b-dropdown-item v-b-modal.modal-edit :to="addtimesheet(data.item.id)">
                  <feather-icon icon="ClockIcon" class="mr-50" />
                  <span>Log Time</span>
                </b-dropdown-item>
              </b-dropdown> -->
            </template>
            <template v-slot:cell(complete)="data">
              <b-form-checkbox v-if="data.item.status == 1 || data.item.status == 3 || data.item.status == 4"
                :checked="isChecked(data.item.id)" :disabled="isDisabled(data.item.status)"
                @change="checkboxChanged(data.item.id, $event)">
              </b-form-checkbox>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
            class="my-0" />

          <b-form-group>
            Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
          </b-form-group>
        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { formatDate } from "@/libs/customFn";
import {
  BButton,
  BSidebar,
  BCard,
  BCardTitle,
  BCardBody,
  BBadge,
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BLink
} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import Sidebar from "./SidebarView.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    FullCalendar,
    BButton,
    BSidebar,
    Sidebar,
    BCard,
    BCardTitle,
    BCardBody,
    BBadge,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormCheckbox,
    DatePicker,
    BDropdown,
    BDropdownItem,
    BLink
  },

  data() {
    return {
      newstatus: false,
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        events: [{}],
        editable: true,
        selectable: true,
        eventClick: this.handleEventClick,
      },
      showSidebar: false,
      selectedItem: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      displayCalendar: false,
      filters: {
        name: "", // String
        status: "", // String or number, depending on your data
        startDate: null, // Date
        endDate: null, // Date
        priority: "", // String
      },
      fields: [
        { key: "name", label: "Job Card Name", sortable: true },
        { key: "startDate", label: "Start Date", formatter: (value, key, item) => item.startDate ? formatDate(item.startDate) : "", sortable: true },
        { key: "endDate", label: "End Date", formatter: (value, key, item) => item.endDate ? formatDate(item.endDate) : "", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "priority", label: "Priority", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      statusOptions: [
        { value: '', text: 'All' },
        { value: 0, text: 'Not Started' },
        { value: 1, text: 'Started' },
        { value: 2, text: 'Completed' },
        { value: 3, text: 'Cancelled' },
        { value: 4, text: 'Blocked' },
      ],
      priorityOptions: [
        { value: "", text: "All" },
        { value: "High", text: "High" },
        { value: "Medium", text: "Medium" },
        { value: "Low", text: "Low" },
      ],
    };
  },

  computed: {
    filteredJobcards() {
      return this.jobcardList.filter((jobcard) => {
        const matchesName =
          !this.filters.name ||
          jobcard.name.toLowerCase().includes(this.filters.name.toLowerCase());

        const matchesStatus =
          this.filters.status === "" || jobcard.status === Number(this.filters.status);

        const matchesStartDate =
          !this.filters.startDate ||
          new Date(jobcard.startDate) >= new Date(this.filters.startDate);

        const matchesEndDate =
          !this.filters.endDate ||
          new Date(jobcard.endDate) <= new Date(this.filters.endDate);

        const matchesPriority =
          this.filters.priority === "" || jobcard.priority === this.filters.priority;

        return matchesName && matchesStatus && matchesStartDate && matchesEndDate && matchesPriority;
      });
    },
    totalRows() {
      return this.filteredJobcards.length; // Dynamically reflect filtered rows
    },
    ...mapGetters("jobcardModule", {
      jobcardList: "jobcards",
      loading: "loading",
    }),
  },

  methods: {
    goToPage(selectedItem) {
    this.$router.push('/jobcard/view/' + selectedItem.id); 
  },
    clearFilters() {
      this.filters = {
        name: "", // String
        status: "", // String or number, depending on your data
        startDate: null, // Date
        endDate: null, // Date
        priority: "", // String
      };
      this.currentPage = 1;
    },
    ...mapActions("jobcardModule", ["getJobcardListAction"]),

    setNewStatus(status) {
      this.newstatus = status;

      if (this.newstatus) {
        window.location.reload();
      }
    },
    handleEventClick(clickInfo) {
      this.showSidebar = !this.showSidebar;
      this.selectedItem = clickInfo.event;
    },
    addtimesheet(item) {
      return "/jobcardtimesheet/add/" + item;
    },
    onRowClicked(item) {
      // This method will handle the row click and navigate to the detail page
      this.$router.push(this.getId(item.id));
    },

    getId(data) {
      return "/jobcard/view/" + data;
    },
  },

  async mounted() {
    await this.getJobcardListAction()
      .then(() => {
        this.calendarOptions.events = this.jobcardList.map((event) => ({
          id: event.id,
          title: event.name,
          start: event.startDate,
          end: event.endDate,
          status: event.status,
          textColor: "#fff",
          backgroundColor:
            event.status === 0
              ? "#4A7CBD" //NS
              : event.status === 1
                ? "#82868B" //S
                : event.status === 2
                  ? "#9FC54C" //C
                  : event.status === 3
                    ? "#BD3736" //CA
                    : event.status === 4
                      ? "#DD8B34" //BL
                      : "#000000",
          borderColor:
            event.status === 0
              ? "#4A7CBD"
              : event.status === 1
                ? "#82868B"
                : event.status === 2
                  ? "#9FC54C"
                  : event.status === 3
                    ? "#BD3736"
                    : event.status === 4
                      ? "#DD8B34"
                      : "#000000",
          color:
            event.status === 0
              ? "#4A7CBD"
              : event.status === 1
                ? "#82868B"
                : event.status === 2
                  ? "#9FC54C"
                  : event.status === 3
                    ? "#BD3736"
                    : event.status === 4
                      ? "#DD8B34"
                      : "#000000",
        }));
      })
      .catch((response) => {
        console.log(response);
      });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
